import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "authForm__h1" }
const _hoisted_2 = { class: "authForm__p" }

import { computed, nextTick, ref } from 'vue';
import { useRouter } from 'vue-router';
/** FSD IMPORTS */
import { EmailSupportButton, Alert } from '@/v2/features';
import { EmailInput, PasswordInput, PhoneInput, LogoTitle, Button } from '@/v2/shared/ui';
import { InvisibleGoogleCaptcha } from '@/v2/shared/lib';
/** LOCAL IMPORT */
import AuthOverlays from './ui/AuthOverlays.vue';
import AuthFormRememberForget from './ui/AuthFormRememberForget.vue';
import { validationRules, defaultAuthFormProps } from './consts';

/** STORE */
import { useStore } from 'vuex';
type loginPayload = {
  email?: string;
  phone?: string;
  password?: string;
  remember_me?: boolean;
  code?: string;
  user_type?: string
};

export default /*#__PURE__*/_defineComponent({
  __name: 'AuthForm',
  props: defaultAuthFormProps,
  setup(__props) {

/** VUE IMPORTS */
const store = useStore()
const payload = ref<loginPayload>({});

const props = __props;

/** captcha */
const captcha = ref<InstanceType<typeof InvisibleGoogleCaptcha>>();
function captchaIsLoading(){
  loading.value = true;
  setTimeout(() => {
    captcha.value?.execute()
  }, 100)
}
/** alert */
const alert = ref<InstanceType<typeof Alert>>();

const router = useRouter()
const loading = ref(false)
const forgotPasswordForm = ref(false);
const recoverMessageShow = ref(false);
const codeInputShow = ref(false);
const phoneValid = ref();
const serverErrors = ref();
const form = ref()
const isEmailAuth = computed(() => props.auth_type === 'Email');
const isPhoneAuth = computed(() => props.auth_type === 'Phone');
const h1 = computed(() => forgotPasswordForm.value ? 'Forgot password' : 'Sign in');
const subtitle = computed(() => forgotPasswordForm.value ? 'Provide the email specified during registration' : 'Use your FGC account');

async function handleResetPassword () {
  const data = {
    email: payload.value.email,
  }
  try{
    await store.dispatch('CmsUserStore/forgotPassword', { payload: data });
    recoverMessageShow.value = true;
  } catch (error : any) {
    alert.value?.show(error)
  }
};
function handleVerificationCode (code : string) {
  const data = { ...payload.value };
  data.code = code
  handleLogin(data)
};

async function handleLogin (data : loginPayload) {
  router.push({ name: 'cms.requests' })
  loading.value = true
  if (data.phone) {
    data.phone = data.phone.replace(/\s/g, '');
  }
  data.user_type = props.user_type
  try {
    const result = await store.dispatch('CmsUserStore/login', { payload: data });
    if(result === 'code' ) {
      codeInputShow.value = true
      return
    }
    if(result === true){
      router.push({ name: 'cms.requests' })
    }
  } catch (error : any) {
    if (error?.response?.data?.success === false) {
      serverErrors.value = ['code']
      await nextTick()
      form.value.validateFields()
    } else {
      alert.value?.show(error)
    }
  } finally {
    loading.value = false
  }
};
async function handleSubmit () {
  if(props.captcha_enabled && captcha.value?.captchaStatus !== 'success'){
    captcha.value?.execute()
    return;
  }
  if (forgotPasswordForm.value) {
    handleResetPassword();
    return;
  }
  const data = { ...payload.value };
  await handleLogin(data);
};
async function clearValidate () {
  serverErrors.value = undefined
  await nextTick()
  form.value.clearValidate()
};
async function resendCodeCallback () {
  loading.value = true
  try {
    const data = payload.value?.email ? { email : payload.value?.email} : { phone : payload.value?.phone }
    const result = await store.dispatch('CmsUserStore/resend', { payload: data });
    if(result.data?.success === true){
      alert.value?.show('New code has been sent', 'success')
    }
    return result.data
  } catch (error : any) {
    alert.value?.show(error)
    return { success: false }
  } finally {
    loading.value = false
  }
};


return (_ctx: any,_cache: any) => {
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    novalidate: "",
    ref_key: "form",
    ref: form,
    model: payload.value,
    rules: _unref(validationRules)(phoneValid.value, serverErrors.value),
    onFinish: handleSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Alert), {
        "show-icon": "",
        class: "alert_absolutly",
        closable: "",
        ref_key: "alert",
        ref: alert
      }, null, 512),
      (_ctx.captcha_enabled)
        ? (_openBlock(), _createBlock(_unref(InvisibleGoogleCaptcha), {
            key: 0,
            ref_key: "captcha",
            ref: captcha,
            onVerify: _cache[0] || (_cache[0] = ($event: any) => {handleSubmit();}),
            onClosed: _cache[1] || (_cache[1] = ($event: any) => {loading.value = false;}),
            onError: _cache[2] || (_cache[2] = ($event: any) => {loading.value = false;}),
            onFail: _cache[3] || (_cache[3] = (msg) =>{
         msg === 'loading' ? captchaIsLoading() : loading.value = false;
      })
          }, null, 512))
        : _createCommentVNode("", true),
      _createVNode(AuthOverlays, {
        recoverMessageShow: recoverMessageShow.value,
        codeInputShow: codeInputShow.value,
        loading: loading.value,
        show_logo: _ctx.show_logo,
        title: _ctx.title,
        support_email: _ctx.support_email,
        resend_time: 30,
        num_inputs: _ctx.num_inputs,
        code_to: _ctx.code_to === 'Email' ? payload.value.email : payload.value.phone,
        closableCodeForm: isPhoneAuth.value && _ctx.code_to === 'Phone' ? true : false,
        onCodeInputShow: _cache[4] || (_cache[4] = ($event: any) => {codeInputShow.value = $event;}),
        onForgotPasswordForm: _cache[5] || (_cache[5] = ($event: any) => {recoverMessageShow.value = $event; forgotPasswordForm.value = $event;}),
        onHandleVerificationCode: handleVerificationCode,
        onClearValidate: clearValidate,
        onResendCode: resendCodeCallback,
        resendCodeCallback: resendCodeCallback
      }, null, 8, ["recoverMessageShow", "codeInputShow", "loading", "show_logo", "title", "support_email", "num_inputs", "code_to", "closableCodeForm"]),
      _createVNode(_unref(LogoTitle), {
        show_logo: _ctx.show_logo,
        title: _ctx.title,
        style: {"margin-bottom":"16px"}
      }, null, 8, ["show_logo", "title"]),
      _createElementVNode("h1", _hoisted_1, _toDisplayString(h1.value), 1),
      _createElementVNode("p", _hoisted_2, _toDisplayString(subtitle.value), 1),
      (isEmailAuth.value || forgotPasswordForm.value)
        ? (_openBlock(), _createBlock(_unref(EmailInput), {
            key: 1,
            value: payload.value.email,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((payload.value.email) = $event)),
            onInput: clearValidate
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (isPhoneAuth.value && !forgotPasswordForm.value)
        ? (_openBlock(), _createBlock(_unref(PhoneInput), {
            key: 2,
            onValidation: _cache[7] || (_cache[7] = ($event: any) => {phoneValid.value = $event;}),
            value: payload.value.phone,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((payload.value.phone) = $event)),
            onInput: clearValidate
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (_ctx.password_input && !forgotPasswordForm.value)
        ? (_openBlock(), _createBlock(_unref(PasswordInput), {
            key: 3,
            value: payload.value.password,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((payload.value.password) = $event)),
            onInput: clearValidate
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        style: _normalizeStyle(_ctx.support_email ? { marginBottom: '24px'} : {})
      }, [
        _createVNode(_unref(Button), {
          block: "",
          html_type: 'submit'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(forgotPasswordForm.value ? 'Submit' : 'Login'), 1)
          ]),
          _: 1
        }),
        (_ctx.remember_me || _ctx.forgot_password)
          ? (_openBlock(), _createBlock(AuthFormRememberForget, {
              key: 0,
              remember_me: _ctx.remember_me,
              forgot_password: _ctx.forgot_password,
              forgotPasswordForm: forgotPasswordForm.value,
              checked: payload.value.remember_me,
              "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((payload.value.remember_me) = $event)),
              onForgotPasswordForm: _cache[11] || (_cache[11] = ($event: any) => {forgotPasswordForm.value = $event; clearValidate()})
            }, null, 8, ["remember_me", "forgot_password", "forgotPasswordForm", "checked"]))
          : _createCommentVNode("", true)
      ], 4),
      (_ctx.support_email)
        ? (_openBlock(), _createBlock(_unref(EmailSupportButton), {
            key: 4,
            support_email: _ctx.support_email
          }, null, 8, ["support_email"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})